import React, { useMemo } from 'react';
import '../core/filters.scss';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import {
    addMightyFitFilter,
    removeMightyFitFilter,
    selectMightyFitFilters,
    selectMightyFitFiltersLoaded,
    selectMightyFitFiltersLoading,
    selectSelectedFilters,
} from '../core/filterSlice';
import { useDispatch, useSelector } from 'react-redux';

export default function FitFilter() {
    const dispatch = useDispatch();
    const mightyFitFilters = useSelector(selectMightyFitFilters);
    const mightyFitFiltersLoading = useSelector(selectMightyFitFiltersLoading);
    const mightyFitFiltersLoaded = useSelector(selectMightyFitFiltersLoaded);
    const selectedFilters = useSelector(selectSelectedFilters);
    const filters = useMemo(() => {
        return mightyFitFilters || {
            difficulty_level: [],
            training_types: [],
            equipments: [],
        };
    }, [mightyFitFilters]);

    const {
        difficulty_level = [],
        training_types = [],
        equipments = [],
    } = filters;

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value, checked } = e.target;

        if (checked) {
            dispatch(addMightyFitFilter(value));
        } else {
            dispatch(removeMightyFitFilter(value));
        }
    };

    const renderCheckboxList = (items: any[], keyField: string, labelField: string, type: string) =>
        items.map((item: any, index: number) => {
            const rawValue = item[keyField]?.toString();
            const value = `${type}:${rawValue}`;
            const isChecked = selectedFilters.includes(value);

            return (
                <li className="checkbox" key={index}>
                    <Form.Check
                        type="checkbox"
                        className="tag-sbmt"
                        name="tag[]"
                        value={value}
                        label={`${item[labelField]} (${item.count})`}
                        id={value}
                        onChange={handleCheckboxChange}
                        checked={isChecked}
                    />
                </li>
            );
        });

    return (
        <div className="wrapfilter">
            {(!mightyFitFiltersLoaded && mightyFitFiltersLoading) ? (
                <div className='text-center mt-5 w-100'>
                    <Spinner className="text-center text-dark" variant="primary" animation="grow" />
                </div>
            ) : (difficulty_level.length <= 0 && training_types.length <= 0 && equipments.length <= 0) ? (
                <div className="text-center mt-5 w-100 text-muted">
                    No filters found
                </div>
            ) : (
                <div className="first-filter">
                    <Row className="filter-row right-filter">
                        <Col sm={3} className="filter-col">
                            <div className="open-filter">
                                <div className="title-box">
                                    <span className="filter-item">Difficulty</span>
                                </div>
                                <div className="check-div">
                                    <div className="scrollbar" id="style-1">
                                        <ul className="filter-ul force-overflow">
                                            {renderCheckboxList(difficulty_level, 'level', 'level', 'difficulty')}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col sm={5} className="filter-col">
                            <div className="open-filter">
                                <div className="title-box">
                                    <span className="filter-item">Training Type</span>
                                </div>
                                <div className="check-div right-ul">
                                    <div className={`${training_types.length > 7 ? 'scrollbar' : ''}`} id="style-1">
                                        <ul className="filter-ul force-overflow">
                                            {renderCheckboxList(training_types, 'slug', 'name', 'training')}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col sm={4} className="filter-col">
                            <div className="open-filter">
                                <div className="title-box">
                                    <span className="filter-item">Equipment</span>
                                </div>
                                <div className="check-div right-ul">
                                    <div className={`${equipments.length > 7 ? 'scrollbar' : ''}`} id="style-1">
                                        <ul className="filter-ul force-overflow">
                                            {renderCheckboxList(equipments, 'slug', 'name', 'equipment')}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            )}
        </div>
    );
}